exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tabs--push-less[data-v-1d809e8a]{overflow-x:auto}", ""]);

// exports
